import pcAdver from "mptcfe-pc-adver"
/**
 * @description 使用PC广告组件库，依赖于window上的MptcfeUtils
 * @param {*} data
 * @param {*} el
 * @param {*} spmCode
 */
const adxAd = function (opt) {
    var data = opt && opt.data
    var el = opt && opt.el
    var spmCode = opt && opt.spmCode
    var resourceId = opt && opt.resourceId
    // axd存在视频广告，对其进行异步加载
    import(/* webpackChunkName: "mptcfe-pc-player" */'mptcfe-pc-player').then((res) => {
        var MptcfePCPalyer = res && res.MptcfePalyer
        window.MptcfePCPalyer = MptcfePCPalyer
        new pcAdver.AdGenerator({
            data: {
                adType: data.adType,
                adData: data,
            },
            location: spmCode,
            resourceId: resourceId,
            success: function (adDom) {
                el.append(adDom[0])
                typeof opt.success === 'function' && opt.success()
            }
        })
    })
}

export default adxAd